if(!getCookieValue("age-verification-ok")){
  document
  let age_verification_block = document.querySelector('.age-verification-block');

  document.documentElement.classList.add("age-verification-block-active");
  

  age_verification_block.querySelectorAll('.answers span').forEach((item)=>{
    item.addEventListener('click',(event)=>{
      if(item.classList.contains('no')){
        location.href = "https://google.com";
        return false;
      }
      document.documentElement.classList.remove("age-verification-block-active");
      setCookie('age-verification-ok','true',365);
    })
  })
}

function getCookieValue(cookieName) {
  const name = cookieName + "=";
  const cookieArray = document.cookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim(); // Trim the whitespace
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}
function setCookie(cookieName, cookieValue, expiryDays) {
  const expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + expiryDate.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}